import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShoppingBag } from "lucide-react";

export default function NotFound() {
  return (
    <section className="container-x px-5 sm:px-8 py-24 sm:py-32 min-h-[65vh]" data-testid="not-found-page">
      <p className="eyebrow mb-5" data-testid="not-found-status">NOCTUA RIVIERA · 404</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white" data-testid="not-found-title">
        Cette page s'est <em className="text-gold">éclipsée.</em>
      </h1>
      <p className="text-gray-300 max-w-xl mt-6" data-testid="not-found-message">
        L'adresse demandée n'existe pas ou n'est plus disponible.
      </p>
      <div className="flex flex-wrap gap-4 mt-10">
        <Link to="/shop" className="btn-gold" data-testid="not-found-shop-link"><ShoppingBag size={16} />Voir le catalogue</Link>
        <Link to="/" className="btn-outline-gold" data-testid="not-found-home-link"><ArrowLeft size={16} />Accueil</Link>
      </div>
    </section>
  );
}